import { render, staticRenderFns } from "./IconSwitcher.vue?vue&type=template&id=cbdd10ba&lang=pug"
import script from "./IconSwitcher.vue?vue&type=script&lang=js"
export * from "./IconSwitcher.vue?vue&type=script&lang=js"
import style0 from "./IconSwitcher.vue?vue&type=style&index=0&id=cbdd10ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports